// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { head } from "ramda";

export const getAppointmentLocation = (appointment) => {
  const participants =
    appointment.appointmentParticipant?.filter(
      ({ type }) => type === "Location"
    ) || [];

  return head(participants)?.location?.address?.text;
};
